import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { APP_CONFIG } from './app/models/constants';

async function main() {
  try {
    const data = await fetch('/assets/config/global-uiconfig.json');
    const config = await data.json();

    if (environment.production) {
      enableProdMode();
    }
    await platformBrowserDynamic([
      { provide: APP_CONFIG, useValue: config },
    ]).bootstrapModule(AppModule)
      .catch(error => console.error('Got an error while setting up Main.ts', error));
  } catch (error) {
    console.error('Got an error while fetching Config file', error);
  }
}

main();